// import React from "react";
// import "./Luxury_Benefit_Of_Bliss.css";
// import Common_Title from "../../common_components/common_title/Common_Title";

// const Luxury_Benefit_Of_Bliss = () => {
//   const data = [
//     {
//       img: "/assets/images/hospitality/ventilation.png",
//       title: "3D Ventilated Fabric",
//     },
//     {
//       img: "/assets/images/hospitality/Layer 13.png",
//       title: "Carbon Manganese Alloy Pocket Springs",
//     },
//     {
//       img: "/assets/images/hospitality/breathable.png",
//       title: "Breathable High-Resilient Foam",
//     },
//     {
//       img: "/assets/images/hospitality/Edge Spring Technology.png",
//       title: "Edge Spring Technology",
//     },
//   ];

//   return (
//     <section className="luxury_benefit_section">
//       <div className="container">
//         {/* <Common_Title title={"Why Choose Us?"} /> */}
//         <div className="luxury_heading">
//           <div className="title-with-lines">
//             <span className="line"></span>
//             <Common_Title title="Luxury Benefit Of Bliss" />
//             <span className="line"></span>
//           </div>
//         </div>

//         <div className="inner_div">
//           <div className="row justify-content-center">
//             {data?.map((item) => {
//               return (
//                 <div className="col-xl-3 col-lg-4 col-sm-6 mb-4">
//                   <div className="blue_card">
//                     <div className="img_holder">
//                       <img src={item?.img} className="inner_img" />
//                     </div>
//                     <div className="text_div">
//                       <p className="title_text">{item?.title}</p>
//                       <p className="descn_text">{item?.descn}</p>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Luxury_Benefit_Of_Bliss;

import React from "react";
import "./Luxury_Benefit_Of_Bliss.css";
import Common_Title from "../../common_components/common_title/Common_Title";
import Common_Luxury_Card from "../../common_components/common_luxury_card/Common_Luxury_Card";

const Luxury_Benefit_Of_Bliss = () => {
  const data = [
    {
      img: "/assets/images/hospitality/ventilation.png",
      title: "3D Ventilated Fabric",
    },
    {
      img: "/assets/images/hospitality/Layer 13.png",
      title: "Carbon Manganese Alloy Pocket Springs",
    },
    {
      img: "/assets/images/hospitality/breathable.png",
      title: "Breathable High-Resilient Foam",
    },
    {
      img: "/assets/images/hospitality/Edge Spring Technology.png",
      title: "Edge Spring Technology",
    },
  ];

  return (
    <section className="luxury_benefit_section">
      <div className="container">
        <div className="luxury_heading">
          <div className="title-with-lines">
            <span className="line"></span>
            <Common_Title title="Luxury Benefit Of Bliss" />
            <span className="line"></span>
          </div>
        </div>

        <div className="inner_div">
          <div className="row justify-content-center">
            {data.map((item, index) => (
              <div key={index} className="col-xl-3 col-lg-4 col-sm-6 mb-4">
                <Common_Luxury_Card
                  img={item.img}
                  title={item.title}
                  descn={item.descn}   
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Luxury_Benefit_Of_Bliss;
